import { Routes } from '@angular/router';
import { TrainingVerifyContainerComponent } from '@app/pages/training/verify/training-verify-container/training-verify-container.component';
import { TrainingVerifyComponent } from '@app/pages/training/verify/training-verify/training-verify.component';
import { DataResolver } from '@app/shared/services/data/data.resolver';


export const VERIFY_ROUTES: Routes = [
  {
    path: 'training/verify',
    children: [
      {
        path: ':training_id',
        component: TrainingVerifyContainerComponent,
        children: [
          {
            path: 'pre',
            component: TrainingVerifyComponent,
          },
          {
            path: 'post',
            component: TrainingVerifyComponent,
          },
        ]
      }
    ]
  },
];
